const STORE_CATEGORIES = [
  {
    categoryId: 1,
    categoryName: 'Eletrônicos'
  },
  {
    categoryId: 2,
    categoryName: 'Varejo'
  },
  {
    categoryId: 3,
    categoryName: 'Moda'
  },
  {
    categoryId: 4,
    categoryName: 'Automotivos'
  },
  {
    categoryId: 5,
    categoryName: 'Saúde'
  },
  {
    categoryId: 6,
    categoryName: 'Presentes'
  },
  {
    categoryId: 7,
    categoryName: 'Móveis'
  },
  {
    categoryId: 8,
    categoryName: 'Esportes'
  },
  {
    categoryId: 9,
    categoryName: 'Eletrodomésticos'
  },
  {
    categoryId: 10,
    categoryName: 'Cosméticos'
  },
  {
    categoryId: 11,
    categoryName: 'Livros'
  },
  {
    categoryId: 12,
    categoryName: 'Tecnologia'
  },
  {
    categoryId: 13,
    categoryName: 'Alimentação'
  },
  {
    categoryId: 14,
    categoryName: 'Decoração'
  },
  {
    categoryId: 15,
    categoryName: 'Viagens'
  },
  {
    categoryId: 16,
    categoryName: 'Produtos Saudáveis'
  },
  {
    categoryId: 17,
    categoryName: 'Serviços'
  },
  {
    categoryId: 18,
    categoryName: 'Perfumarias'
  },
  {
    categoryId: 19,
    categoryName: 'Bebidas'
  },
  {
    categoryId: 20,
    categoryName: 'Óticas'
  }
]

module.exports = {
  STORE_CATEGORIES
}



// WEBPACK FOOTER //
// ./src/services/constants.js